import { Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import FeatherIcon from 'feather-icons-react'
import { sendVisitLog } from 'helpers/visitLogger'
import { colors } from '../../styles/colors'

type MenuProps = {
    showDownload?: boolean
    navClass?: string
    buttonClass?: string
    loggedInUser?: {}
    BlogPage?: boolean
}

const Menu1 = ({ navClass, showDownload }: MenuProps) => {
    console.log('MenuProps', { navClass, showDownload });

    const location = useLocation()
    const pageType = (location.state as any)?.type;

    // const isActive = (path: string) => {
    //     if (path === "/") return location.pathname === "/";
    //     if (path === "/blogs") {

    //         const staticRoutes = ["/", "/features", "/about", "/contact", "/privacy", "/termsAndConditions"];
    //         if (location.pathname === "/blogs") return true;

    //         return !staticRoutes.includes(location.pathname) && location.pathname.split("/").length === 2 && location.pathname !== "";
    //     }
    //     return location.pathname.startsWith(path);
    // };
    const isActive = (path: string) => {
        if (path === "/") return location.pathname === "/";

        if (path === "/blogs") {
            // ✅ only blog pages
            if (location.pathname === "/blogs") return true;
            return pageType === "blog";
        }

        // if (path === "/blogs") {
        //     return location.pathname.startsWith("/blogs");
        // }

        if (path === "/industries") {
            // ✅ only industry pages
            if (location.pathname === "/industries") return true;
            return pageType === "industry";
        }

        return location.pathname.startsWith(path);
    };

    return (
        <Nav as="nav" className={classNames("align-items-lg-center ms-auto", navClass)}>

            <Nav.Link
                as={Link}
                to="/"
                className={classNames({ active: isActive("/") })}
                onClick={() => sendVisitLog("/")}
            >
                Home
            </Nav.Link>
            <Nav.Link
                as={Link}
                to="/features"
                className={classNames({ active: isActive("/features") })}
            >
                Features
            </Nav.Link>
            <Nav.Link
                as={Link}
                to="/industries"
                className={classNames({ active: isActive("/industries") })}
            >
                Industries
            </Nav.Link>
            <Nav.Link
                as={Link}
                to="/about"
                className={classNames({ active: isActive("/about") })}
            >
                About
            </Nav.Link>
            <Nav.Link
                as={Link}
                to="/contact"
                className={classNames({ active: isActive("/contact") })}
            >
                Contact
            </Nav.Link>

            <Nav.Link
                as={Link}
                to="/blogs"
                className={classNames({ active: isActive("/blogs") })}
            >
                Blogs
            </Nav.Link>

            {showDownload && (
                <>
                    <Link
                        to="/contact"
                        className="btn ms-lg-3"
                        style={{ backgroundColor: colors.primary.teal1, color: "#fff" }}
                    >
                        Book a Demo
                    </Link>

                    {/* <a
                        href="tel:+447775168068"
                        className="ms-lg-3 d-flex align-items-center gap-2 text-dark fw-semibold"
                    >
                        <FeatherIcon icon="phone" size={16} />
                        +44 7775 168068
                    </a> */}
                    <a
                        href="https://wa.me/447775168068"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Chat on WhatsApp"
                        className="ms-lg-3 d-flex align-items-center gap-2 text-dark fw-semibold"
                    >
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
                            alt="whatsapp"
                            width="18"
                            height="18"
                        />
                        +44 7775 168068
                    </a>
                </>
            )}
        </Nav>
    )
}

export default Menu1